
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1710"}},[_c('path',{attrs:{"data-name":"Rectangle 2412","fill":"none","d":"M0 0h25v20H0z"}}),_c('path',{attrs:{"data-name":"Path 1061","d":"M22 5h-1.057V3.5a1.5 1.5 0 00-3 0V9h-10.9V3.5a1.5 1.5 0 00-3 0V5H2.99a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5h1.053v1.5a1.5 1.5 0 003 0V13h10.9v5.5a1.5 1.5 0 003 0V17h1.053a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0022 5z","fill":"#3c3c3c"}})])])
          )
        }
      }
    